import Vue from 'vue';
import App from './AppDtm.vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/localization/i18n.js';
import VueMatomo from 'vue-matomo';

const { proj4 } = require('@/assets/js/scripts/webgis/proj4/proj4.js');

//import {PIWIK_URL} from '@/configs/PiwikUrlConfig.js';
console.log("Using PIWIK_URL: " + process.env.VUE_APP_PIWIK_URL + " with site: " + process.env.VUE_APP_PIWIK_SITE_ID);

Vue.config.productionTip = false

Vue.use(VueMatomo, {
  //host: "http://sigma.genegis.it/matomo/",
  //siteId: 3,
  host: process.env.VUE_APP_PIWIK_URL,
  siteId: process.env.VUE_APP_PIWIK_SITE_ID,
  trackerFileName: 'matomo',
  // router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});

new Vue({
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')